import React from "react";
import { BadgeCheck, CreditCard, Headphones, Star, Truck } from "lucide-react";

const reasons = [
  {
    icon: Truck,
    title: "Free Home Delivery",
    description: "Free home delivery across Hyderabad for your celebrations.",
  },
  {
    icon: BadgeCheck,
    title: "Standard Crackers only",
    description: "Hyderabad's Trusted Exclusive Standard Crackers Store",
  },
  {
    icon: CreditCard,
    title: "Pay On Delivery Only",
    description: "Pay On Delivery via cash or UPI. Card payment not accepted.",
  },
  {
    icon: Headphones,
    title: "Customer Support",
    description: "Friendly help before, during, and after your order.",
  },
  {
    icon: Star,
    title: "Trusted Since 2001",
    description: "Helping Hyderabad families celebrate Diwali for generations.",
  },
];

export function WhyChooseUs() {
  return (
    <section className="mt-10 border-y border-hyd-border bg-hyd-panel">
      <div className="max-w-6xl mx-auto px-4 py-10 sm:py-14">
        <div className="text-center">
          <div className="text-[11px] uppercase tracking-[0.25em] font-bold text-hyd-gold">Why us</div>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold mt-2">Why Choose Hyderabad Crackers</h2>
          <p className="text-sm sm:text-base text-hyd-text2 mt-2">A trusted, responsible way to celebrate together.</p>
        </div>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {reasons.map(({ icon: Icon, title, description }, index) => (
            <article
              key={title}
              className="relative overflow-hidden rounded-2xl border border-hyd-border bg-hyd-bg/70 p-4 text-center hover:border-hyd-gold/50 transition-colors"
            >
              <span className="absolute right-2 top-0 font-display text-4xl font-extrabold text-hyd-gold/10">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div className="relative mx-auto w-11 h-11 rounded-2xl bg-hyd-red text-white grid place-items-center">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="relative font-display font-bold mt-3">{title}</h3>
              <p className="text-xs leading-relaxed text-hyd-text2 mt-1">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
